import {Template} from "../../../../components/template/template.jsx";
import {Card} from "../../../../components/card/card.jsx";
import {useCallback, useMemo, useRef, useState} from "react";
import {agGridShiftComparator, workScheduleSpecialCases} from "../work-schedule/form/utils/work-schedule-utils.js";
import JourneyService from "../../../../services/web/journey.service.js";
import {DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL} from "../../../../utils/ag-grid-columns-utils.js";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import {useQuery} from "@tanstack/react-query";
import projectUtils from "../../../../utils/project-utils.js";
import ToggleCellRender from "./components/toggle-cell-renderer.jsx";

const specialCaseArr = workScheduleSpecialCases
const JourneyList = () => {
    const [tableData, setTableData] = useState([]);
    const gridRef = useRef(null)

    const defaultColDef = {...DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL, sortable: true};

    const onToggleChangeFromParent = useCallback(async (id, pattern, newStatus, rowData) => {
        const requestBody = [{
            id: id,
            pattern: pattern,
            status: newStatus
        }];

        try {
            await JourneyService.toggleJourney(requestBody);

            if (gridRef.current.api) {
                gridRef.current.api.applyTransaction({
                    update: [{ ...rowData, status: newStatus }]
                });
            }

        } catch (error) {
            console.error('Erro ao atualizar status da jornada:', error);
            if (gridRef.current.api) {
                gridRef.current.api.applyTransaction({
                    update: [{ ...rowData, status: !newStatus }]
                });
            }

            projectUtils.swalMessage("warning", "Atenção", "Não é possível desabilitar uma jornada associada a uma equipe.", "Ok");
        }
    }, []);

    const columnDefs = useMemo(() => [
        { headerName: "ID", field: "id", flex: 1},
        { headerName: "Jornada de trabalho", field: "pattern", sort: 'asc', sortingOrder: ["asc", "desc"],  flex: 1,
            valueFormatter: ({value}) => {
                const foundScale = specialCaseArr.find(scale => scale.id === value.toUpperCase())
                return foundScale ? foundScale.name : value
            },
            comparator: agGridShiftComparator
        },
        {
            headerName: "Status",
            field: "status",
            flex: 1,
            cellRenderer: ToggleCellRender,
            cellRendererParams: {
                onToggleChange: onToggleChangeFromParent
            },
        },
    ], []);

    const defaultColumnState = [
        {
            colId: "pattern",
            sort: "asc",
            sortIndex: 0
        }
    ];

    useQuery({
        queryFn: () => JourneyService.getAllJourneys().then(({data}) => {
            setTableData(data)
            return data
        }),
        queryKey: ['work-schedule-journeys']
    })

    return(
        <Template>
            <Template.Header>
                <Template.Title>
                    Jornadas
                </Template.Title>
            </Template.Header>
            <Template.Body>
                <Card>
                    <Card.Header>
                        <Card.Title>Jornadas habilitadas para configuração de equipes</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <div className="h-[calc(100vh-123px)]">
                            <AgGridReact
                                ref={gridRef}
                                rowData={tableData}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                animateRows={false}
                                pagination={true}
                                onGridReady={(params) => {
                                    params.columnApi.applyColumnState({
                                        state: defaultColumnState,
                                        applyOrder: true
                                    });
                                }}
                                onSortChanged={(params) => {
                                    const sortedCols = params.columnApi
                                        .getColumnState()
                                        .filter(col => col.sort);

                                    if (sortedCols.length === 0) {
                                        params.columnApi.applyColumnState({
                                            state: defaultColumnState,
                                            applyOrder: true
                                        });
                                    }
                                }}

                                paginationPageSize={20}
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                getRowId={(params) => String(params.data.id)}
                                gridOptions={{localeText: aggridUtils.localization()}}
                                theme={aggridUtils.generalTheme()}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    )
}

export default JourneyList;